// @flow
// @ts-nocheck
import { handleActions } from 'redux-actions';
import { Map, List, fromJS } from 'immutable';
// eslint-disable-next-line flowtype/no-weak-types
export var initialState = Map({
    currentPage: 0,
    data: List(),
    loaded: false,
    loadedAll: false,
    loading: false,
    loadingAll: false,
    pageCount: 0,
});
var updateEntry = function (entry) { return function (existing) {
    // $FlowIgnoreNextLine
    var index = existing.findIndex(function (existingEntry) { return existingEntry.get('id') === entry.get('id'); });
    if (index === -1) {
        // $FlowIgnoreNextLine
        return existing.push(entry);
    }
    // $FlowIgnoreNextLine
    return existing.set(index, entry);
}; };
var updateEntries = function (entries) { return function (existing) {
    if (existing.size === 0) {
        return entries;
    }
    var newEntries = existing;
    entries.forEach(function (device) {
        // $FlowIgnoreNextLine
        newEntries = newEntries.update(updateEntry(device));
    });
    return newEntries;
}; };
var reducer = handleActions({
    GET_CATEGORY: function (state) { return state.set('loading', true); },
    GET_CATEGORY_COMPLETE: {
        next: function (state, action) {
            return state
                .set('loading', false)
                .set('loaded', true)
                .update('data', updateEntry(action.payload));
        },
        throw: function (state) {
            return state.set('loading', false).set('loaded', false);
        },
    },
    GET_CATEGORIES: function (state) { return state.set('loadingAll', true); },
    GET_CATEGORIES_COMPLETE: {
        next: function (state, action) {
            return state
                .set('loadingAll', false)
                .set('loadedAll', true)
                .set('total', action.payload.totalElements)
                .set('page', action.payload.page)
                .set('pageCount', action.payload.totalPages)
                .update('data', updateEntries(fromJS(action.payload.content)));
        },
        throw: function (state) {
            return state.set('loadingAll', false).set('loadedAll', false);
        },
    },
    RESET_CATEGORIES: function (state) {
        return state.set('data', List()).set('currentPage', 0);
    },
}, initialState);
export default reducer;
